module.exports = __webpack_public_path__ + "static/img/role2-c1508018.5182434.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/role2-c1508018.png
// module id = sRDI
// module chunks = 1